
import { BlogPost } from "./types";
import { circadianRhythmOptimization } from "./circadian-rhythm-optimization";
import { cognitiveLoadManagement } from "./cognitive-load-management";
import { ultradianRhythmsProductivity } from "./ultradian-rhythms-productivity";
import { sleepRecoveryOptimization } from "./sleep-recovery-optimization";
import { chronotypesProductivityStrategies } from "./chronotypes-productivity-strategies";
import { heartRateVariabilityCognitivePerformance } from "./heart-rate-variability-cognitive-performance";
import { scienceOfLightCircadianEntrainment } from "./science-of-light-circadian-entrainment";
import { cortisolAwakeningResponse } from "./cortisol-awakening-response";
import { adenosineStrategicCaffeine } from "./adenosine-strategic-caffeine";
import { coreBodyTemperaturePerformance } from "./core-body-temperature-performance";
import { mealTimingCircadianMetabolism } from "./meal-timing-circadian-metabolism";
import { exerciseTimingOptimization } from "./exercise-timing-optimization";
import { strategicNappingScience } from "./strategic-napping-science";
import { melatoninSleepOptimization } from "./melatonin-sleep-optimization";
import { stressCortisolRecovery } from "./stress-cortisol-recovery";

export const blogPosts: BlogPost[] = [
  circadianRhythmOptimization,
  cognitiveLoadManagement,
  ultradianRhythmsProductivity,
  sleepRecoveryOptimization,
  chronotypesProductivityStrategies,
  heartRateVariabilityCognitivePerformance,
  scienceOfLightCircadianEntrainment,
  cortisolAwakeningResponse,
  adenosineStrategicCaffeine,
  coreBodyTemperaturePerformance,
  mealTimingCircadianMetabolism,
  exerciseTimingOptimization,
  strategicNappingScience,
  melatoninSleepOptimization,
  stressCortisolRecovery
];

export * from "./types";
